import { Repl } from "@electric-sql/pglite-repl";
import { Box } from "@mui/material";

import { client } from "@/db/db";
import ModalForm from "@/elements/ModalForm";
export default function SqlEditor({ open, close }: { open: boolean; close: () => void }) {
  return (
    <ModalForm
      maxWidth={1800}
      maxHeight={1200}
      sx={{
        padding: 2,
        height: "calc(100vh - 300px)",
      }}
      open={open}
      onClose={() => close()}
    >
      <Box sx={{ width: "100%", height: "100%" }}>
        <Repl pg={client} border={true} theme="dark" />
      </Box>
    </ModalForm>
  );
}
